<div class="whole-modal" style="padding: 15px">
    <h3 *ngIf="modalMode === 'add'">Add User type</h3>
    <h3 *ngIf="modalMode == 'edit'">Edit User type</h3>
    <h3 *ngIf="modalMode == 'copy'">Copy User type</h3>
    <h3 *ngIf="modalMode == 'view'">View User type</h3>
    <!-- <input type="text" style="display: none;"> -->
    <hr />
    <div class="header mb-3">
        <div class="input-fields">
            <div class="row">
                <div class="col-3" [formGroup]="roleForm">
                    <mat-label class="font-style">Role Name</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            formControlName="roleName"
                            id="roleName"
                            matInput
                            placeholder="Enter user type here"
                            [(ngModel)]="permissionTreeData.name"
                            (input)="checkIsNameChanged($event)"
                            #roleName
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                    <span
                        class="text-danger"
                        *ngIf="
                            roleForm.controls['roleName'].hasError('required') && (roleForm.controls['roleName'].dirty || roleForm.controls['roleName'].touched)
                        "
                        >Please enter valid security role name.</span
                    >
                </div>
                <div class="col-8">
                    <mat-label class="font-style">Description</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            id="Description"
                            matInput
                            placeholder="Enter description here"
                            name="asset_icon"
                            [(ngModel)]="permissionTreeData.description"
                            #description
                            [disabled]="isDisable == true"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <mat-label class="font-style" style="padding-bottom: 10px">Permission</mat-label>
    <div class="table-container" *ngIf="dataSource">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 permission-table">
            <ng-container matColumnDef="permission name">
                <th mat-header-cell *matHeaderCellDef>
                    <span [style.paddingLeft.px]="40">Permission Name </span>
                </th>
                <td class="permision-table-cell" mat-cell *matCellDef="let data">
                    <div class="d-flex align-items-center">
                        <button
                            mat-icon-button
                            [style.visibility]="!data.expandable ? 'hidden' : ''"
                            [style.marginLeft.px]="data.level * 20"
                            (click)="toggleData(data)"
                        >
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>

                        <span>{{ data.name }}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Create">
                <th mat-header-cell *matHeaderCellDef>Create</th>
                <td class="permision-table-cell" mat-cell *matCellDef="let data">
                    <div *ngIf="checkColumnExist('Create', data.actions); else else_template">
                        <div *ngFor="let option of data.actions; let i = index">
                            <div *ngIf="data.actions[i].securityPermissionColumn.name === 'Create'">
                                <div *ngIf="data.actions[i].securityPermissionColumn.name === 'Create' && data.expandable; else non_indeterminate_checkbox">
                                    <div class=""></div>
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoItemSelectionToggleCreateColumn(data, data.actions[i].allowed)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </div>
                                <!-- [checked]="descendantsAllSelectedCreateColumn(data, 'Create')"
                                    [indeterminate]="descendantsPartiallySelectedCreateColumn(data, 'Create')"-->
                                <ng-template #non_indeterminate_checkbox>
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoLeafItemSelectionToggleCreateColumn(data)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <ng-template #else_template>
                        <mat-checkbox [disabled]="true" class="example-margin checkbox-wrap"></mat-checkbox>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="write">
                <th mat-header-cell *matHeaderCellDef>Modify</th>
                <td class="permision-table-cell" mat-cell *matCellDef="let data">
                    <!-- <mat-checkbox class="example-margin checkbox-wrap">View</mat-checkbox> -->
                    <div *ngIf="checkColumnExist('Modify', data.actions); else else_template_modify">
                        <div *ngFor="let option of data.actions; let i = index">
                            <div *ngIf="data.actions[i].securityPermissionColumn.name === 'Modify'">
                                <div
                                    *ngIf="
                                        data.actions[i].securityPermissionColumn.name === 'Modify' && data.expandable;
                                        else non_indeterminate_checkbox_modify
                                    "
                                >
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoItemSelectionToggleModifyColumn(data, data.actions[i].allowed)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </div>
                                <!-- [indeterminate]="descendantsPartiallySelectedModifyColumn(data, 'Modify')"
                                    [checked]="descendantsAllSelectedModifyColumn(data, 'Modify')" -->
                                <ng-template #non_indeterminate_checkbox_modify>
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoLeafItemSelectionToggleModifyColumn(data)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <ng-template #else_template_modify>
                        <mat-checkbox [disabled]="true" class="example-margin checkbox-wrap"></mat-checkbox>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="View">
                <th mat-header-cell *matHeaderCellDef>View</th>
                <td class="permision-table-cell" mat-cell *matCellDef="let data">
                    <!-- <mat-checkbox class="example-margin checkbox-wrap">View</mat-checkbox> -->
                    <div *ngIf="checkColumnExist('View', data.actions); else else_template_view">
                        <div *ngFor="let option of data.actions; let i = index">
                            <div *ngIf="data.actions[i].securityPermissionColumn.name === 'View'">
                                <div *ngIf="data.actions[i].securityPermissionColumn.name === 'View' && data.expandable; else non_indeterminate_checkbox_view">
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoItemSelectionToggleViewColumn(data, data.actions[i].allowed)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </div>
                                <!-- [indeterminate]="descendantsPartiallySelectedViewColumn(data, 'View')"
                                    [checked]="descendantsAllSelectedViewColumn(data, 'View')"  -->
                                <ng-template #non_indeterminate_checkbox_view>
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoLeafItemSelectionToggleViewColumn(data)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <ng-template #else_template_view>
                        <mat-checkbox [disabled]="true" class="example-margin checkbox-wrap"></mat-checkbox>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef>Delete</th>
                <td class="permision-table-cell" mat-cell *matCellDef="let data">
                    <!-- <mat-checkbox class="example-margin checkbox-wrap">View</mat-checkbox> -->
                    <div *ngIf="checkColumnExist('Delete', data.actions); else else_template_delete">
                        <div *ngFor="let option of data.actions; let i = index">
                            <div *ngIf="data.actions[i].securityPermissionColumn.name === 'Delete'">
                                <div
                                    *ngIf="
                                        data.actions[i].securityPermissionColumn.name === 'Delete' && data.expandable;
                                        else non_indeterminate_checkbox_delete
                                    "
                                >
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoItemSelectionToggleDeleteColumn(data, data.actions[i].allowed)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </div>
                                <!-- [indeterminate]="descendantsPartiallySelectedDeleteColumn(data, 'Delete')"
                                    [checked]="descendantsAllSelectedDeleteColumn(data, 'Delete')" -->
                                <ng-template #non_indeterminate_checkbox_delete>
                                    <mat-checkbox
                                        [(ngModel)]="data.actions[i].allowed"
                                        class="example-margin checkbox-wrap"
                                        (change)="todoLeafItemSelectionToggleDeleteColumn(data)"
                                        [disabled]="isDisable == true"
                                    ></mat-checkbox>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <ng-template #else_template_delete>
                        <mat-checkbox [disabled]="true" class="example-margin checkbox-wrap"></mat-checkbox>
                    </ng-template>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
    <div class="modal-footer">
        <!-- <button mat-button class="btn secondary-ebtn" (click)="this.ngbActiveModal.close()">Cancel</button>
    <button type="button" class="btn primary-ebtn" (click)="sendResults(roleName.value,description.value)">Add User
      Type</button> -->
        <button class="btn secondary-ebtn" (click)="closeModalWithCancel()">Cancel</button>
        <!-- <button type="button" *ngIf="modalMode==='edit'" (click)="closeModalWithChanges()" class="btn primary-ebtn">Edit User Type</button>
    <button type="button" *ngIf="modalMode==='add'"  (click)="closeModalWithChanges()" class="btn primary-ebtn">Add User Type</button> -->
        <button type="button" *ngIf="isDisable == false" (click)="closeModalWithChanges()" class="btn primary-ebtn">Save</button>
    </div>
    <!-- <button (click)="temp()">Show Check</button> -->
</div>
